// Always-visible Floating Action Buttons.
// Bottom-right corner (RTL: bottom-left). Two distinct buttons:
//   • 🎨 Theme   — opens picker modal
//   • 🌐 Lang    — flips AR/EN with reload
//
// position: fixed → guaranteed visible regardless of v16's DOM (including
// the /desk home where neither .body-sidebar nor .standard-actions exist).

import { theme } from "./prefs.js";
import { themePicker } from "./theme_picker.js";
import { t } from "../utils/i18n.js";
import { svg } from "../utils/icons.js";

const ID = "e16-fab";

function build() {
	if (document.getElementById(ID)) return;
	if (document.body && document.body.classList.contains("e16-embed")) return;

	const lng = theme.currentLang();
	const root = document.createElement("div");
	root.id = ID;
	root.className = "e16-fab-root";
	root.innerHTML = `
		<button type="button" class="e16-fab e16-fab--theme"
			aria-label="${t("Switch theme", lng)}"
			data-tooltip="${t("Switch theme", lng)}">
			${svg("cog", { size: 22 })}
		</button>
		<button type="button" class="e16-fab e16-fab--lang"
			aria-label="${t("Switch language", lng)}"
			data-tooltip="${t("Switch language", lng)}">
			${svg("globe", { size: 22 })}
		</button>
	`;

	const [themeBtn, langBtn] = root.querySelectorAll(".e16-fab");
	themeBtn.addEventListener("click", () => {
                const next = theme.currentMode() === "light" ? "dark" : "light";
                theme.applyMode(next);
        });
	langBtn.addEventListener("click", () => {
		const next = theme.currentLang() === "ar" ? "en" : "ar";
		theme.applyLang(next, { persist: true, reload: true });
	});

	(document.body || document.documentElement).appendChild(root);
}

export const fab = {
	mount() {
		const tryBuild = () => { if (document.body) build(); };
		tryBuild();
		setTimeout(tryBuild, 300);
		setTimeout(tryBuild, 1200);
		setTimeout(tryBuild, 3000);

		const obs = new MutationObserver(() => {
			if (!document.getElementById(ID)) tryBuild();
		});
		if (document.body) obs.observe(document.body, { childList: true, subtree: false });
		else document.addEventListener("DOMContentLoaded", () => {
			obs.observe(document.body, { childList: true, subtree: false });
			tryBuild();
		}, { once: true });
	},
};
